<template>
  <div>
    <el-dialog
      title="提示"
      :visible.sync="show"
      width="650px"
      append-to-body
      custom-class="winner-workflow"
    >
      <p>{{ message ? message[0] : '您选择的流程/表单/节点不一致！' }}</p>
      <p style="color: red">
        {{ message ? message[1] : '注意： 由于不同节点显示的内容可能不一样，所选择的流程表单、节点必须一致，否则可能报错！' }}
      </p>
      <div slot="footer">
        <el-button
          type="primary"
          @click="handleShowError"
        >
          错误明细
        </el-button>
        <el-button
          @click="show = false"
        >
          关 闭
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="错误信息"
      :visible.sync="showError"
      width="900px"
      append-to-body
    >
      <el-table
        v-if="showTable"
        :data="tableData"
        border
      >
        <el-table-column
          label="表单号"
          :minWidth="200"
        >
          <div
            slot-scope="scope"
            class="public-form-table-item-operate"
          >
            <a @click="open(scope.row)">{{ scope.row.businessKey }}</a>
          </div>
        </el-table-column>
        <template v-for="item in tableCol">
          <el-table-column
            v-if="!hide.includes(item.key)"
            :key="item.key"
            :prop="item.key"
            :label="item.label"
            :min-width="item.minWidth"
          />
        </template>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import handleButton from '@workflow/mixins/handleButton.js'
export default {
  mixins: [handleButton],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default() {
        return []
      }
    },
    message: {
      type: Array,
      default: null
    },
    hide: {
      type: Array,
      default() {
        return ['processDefinitionKey']
      }
    }
  },
  data() {
    return {
      show: false,
      showError: false,
      showTable: false,
      tableCol: [
        { label: '流程模型key', key: 'modelKey', minWidth: 200 },
        { label: '流程模型key', key: 'processDefinitionKey', minWidth: 200 },
        { label: '表单版本', key: 'formDefinitionId', minWidth: 170 },
        { label: '节点id', key: 'taskDefKey', minWidth: 150 }
      ]
    }
  },
  computed: {
    tableData() {
      return this.data || []
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.show = true
      }
    },
    showError(val) {
      if (val) {
        this.showTable = val
      } else {
        setTimeout(() => {
          this.showTable = val
        }, 300)
      }
    },
    show(val) {
      if (!val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleShowError() {
      this.show = false
      setTimeout(() => {
        this.showError = true
      }, 300)
    }
  }
}

</script>
